import React, { createContext } from 'react'
import { TCloseModal, TShowModal } from '../api-context'

export interface ITableBaseContext {
  showModal: TShowModal
  closeModal: TCloseModal
}

export const TableBaseContext = createContext<ITableBaseContext>({
  showModal: () => {},
  closeModal: () => {}
})

export const MapTableBaseContext = (context: (context: ITableBaseContext) => React.ReactNode) => (
  <TableBaseContext.Consumer>{context}</TableBaseContext.Consumer>
)
